export default {
  feedback: {
    usage_threshold: 'Minimalna kwota koszyka dla tej promocji wynosi (bez kosztów dostawy)',
    promo_code_added: 'Kod promocyjny zastosowany',
    promo_code_removed: 'Kod promocyjny {{code}} usunięty',
  },
};
